import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ApiWave } from "@/generated/models/ApiWave";
import MyStreamWaveDesktopTabs from "../MyStreamWaveDesktopTabs";
import { useContentTab } from "@/components/brain/ContentTabContext";
import { useSidebarState } from "../../../../hooks/useSidebarState";
import { ChevronDoubleLeftIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";
import WavePicture from "../../../waves/WavePicture";
import { useRouter, useSearchParams, usePathname } from "next/navigation";
import { createBreakpoint } from "react-use";
const useBreakpoint = createBreakpoint({
  LG: 1024,
  S: 0
});
interface MyStreamWaveTabsDefaultProps {
  readonly wave: ApiWave;
}
const MyStreamWaveTabsDefault: React.FC<MyStreamWaveTabsDefaultProps> = t0 => {
  const $ = _c(34);
  const {
    wave
  } = t0;
  const {
    activeContentTab,
    setActiveContentTab
  } = useContentTab();
  const {
    toggleRightSidebar,
    isRightSidebarOpen
  } = useSidebarState();
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === "S";
  let t1;
  if ($[0] !== pathname || $[1] !== router || $[2] !== searchParams) {
    t1 = () => {
      const params = new URLSearchParams(searchParams?.toString() || "");
      params.delete("wave");
      const newUrl = params.toString() ? `${pathname}?${params.toString()}` : pathname || "/waves";
      router.push(newUrl, {
        scroll: false
      });
    };
    $[0] = pathname;
    $[1] = router;
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleMobileBack = t1;
  let t2;
  if ($[4] !== handleMobileBack || $[5] !== isMobile) {
    t2 = isMobile && <button onClick={handleMobileBack} className="tw-flex tw-items-centertw-h-full tw-px-2.5 -tw-ml-2.5 tw-mr-1.5 tw-bg-transparent tw-border-0 tw-text-iron-300 hover:tw-text-iron-50 tw-transition-colors tw-p-0" aria-label="Go back"><ArrowLeftIcon className="tw-w-6 tw-h-6 tw-flex-shrink-0" /></button>;
    $[4] = handleMobileBack;
    $[5] = isMobile;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = wave.name;
  const t4 = wave.picture;
  let t5;
  if ($[7] !== wave.contributors_overview) {
    t5 = wave.contributors_overview.map(_temp);
    $[7] = wave.contributors_overview;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5 || $[10] !== wave.name || $[11] !== wave.picture) {
    t6 = <div className="tw-size-6 lg:tw-size-9 tw-flex-shrink-0 tw-ring-1 tw-ring-offset-1 tw-ring-offset-iron-950 tw-ring-white/30 tw-rounded-full"><WavePicture name={t3} picture={t4} contributors={t5} /></div>;
    $[9] = t5;
    $[10] = wave.name;
    $[11] = wave.picture;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== wave.name) {
    t7 = <h1 className="tw-ml-3 tw-text-sm lg:tw-text-xl tw-font-semibold tw-text-white/95 tw-tracking-tight tw-mb-0 tw-truncate">{wave.name}</h1>;
    $[13] = wave.name;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t2 || $[16] !== t6 || $[17] !== t7) {
    t8 = <div className="tw-flex tw-items-center">{t2}{t6}{t7}</div>;
    $[15] = t2;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = `tw-h-4 tw-w-4 tw-flex-shrink-0 tw-text-iron-200 tw-transition tw-duration-300 ${isRightSidebarOpen ? "tw-rotate-180 desktop-hover:group-hover:tw-translate-x-0.5" : "tw-rotate-0 desktop-hover:group-hover:-tw-translate-x-0.5"}`;
  let t10;
  if ($[19] !== t9) {
    t10 = <ChevronDoubleLeftIcon strokeWidth={2} className={t9} />;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== toggleRightSidebar) {
    t11 = <div className="tw-relative tw-flex tw-items-center tw-self-stretch"><button type="button" onClick={toggleRightSidebar} className="tw-group tw-absolute tw-top-1/2 -tw-translate-y-1/2 tw-right-0 tw-flex tw-items-center tw-justify-center tw-h-8 tw-w-8 tw-rounded-xl tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-800 tw-backdrop-blur-sm tw-shadow-[0_12px_28px_rgba(0,0,0,0.35)] tw-transition tw-duration-300 tw-ease-out desktop-hover:hover:tw-border-iron-500/80 desktop-hover:hover:tw-bg-iron-700/85 desktop-hover:hover:tw-shadow-[0_16px_34px_rgba(0,0,0,0.4)]" aria-label="Toggle right sidebar">{t10}</button></div>;
    $[21] = t10;
    $[22] = toggleRightSidebar;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t8) {
    t12 = <div className="tw-flex tw-items-center tw-justify-between tw-gap-x-4 tw-px-2 sm:tw-px-4 tw-py-3 tw-border-b tw-border-solid tw-border-iron-800 tw-border-x-0 tw-border-t-0">{t8}{t11}</div>;
    $[24] = t11;
    $[25] = t8;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== activeContentTab || $[28] !== setActiveContentTab || $[29] !== wave) {
    t13 = <div className="tw-border-b tw-border-solid tw-border-iron-800 tw-border-l-0 tw-border-t-0"><MyStreamWaveDesktopTabs activeTab={activeContentTab} wave={wave} setActiveTab={setActiveContentTab} /></div>;
    $[27] = activeContentTab;
    $[28] = setActiveContentTab;
    $[29] = wave;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t12 || $[32] !== t13) {
    t14 = <div className="tw-w-full tw-flex tw-flex-col tw-bg-iron-950">{t12}{t13}</div>;
    $[31] = t12;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  return t14;
};
export default MyStreamWaveTabsDefault;
function _temp(c) {
  return {
    pfp: c.contributor_pfp
  };
}